module.exports = __webpack_public_path__ + "media/images/emblems/Bretigny-sur-Morrens-coat_of_arms-5b710d27cbdb07d45f2ffaa46b692cab.svg";